module.exports = __webpack_public_path__ + "static/media/step1_gif.766a06c8.gif";